module.exports = __webpack_public_path__ + "static/media/casa_pancha.9a611f51.jpg";